import axios from 'axios';

const getAdviceNotes = (topics) => {
  const config = {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
  };

  const body = {
    inputData: topics,
  };

  return axios.post(`${process.env.NEXT_PUBLIC_GRAPPLE_BACKEND_URL}advice-note`, body, config);
};

export default getAdviceNotes;
